import { render, staticRenderFns } from "./downSalaryReward.vue?vue&type=template&id=fde6bfc4&"
import script from "./downSalaryReward.vue?vue&type=script&lang=js&"
export * from "./downSalaryReward.vue?vue&type=script&lang=js&"
import style0 from "./downSalaryReward.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports